import React, { useEffect } from "react";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import If from "../../../../../vendors/components/If";
import { Card } from "primereact/card";
import SessaoPresencialVisualizar from "../../../../components/sessao-presencial/SessaoPresencialVisualizar";
import SessaoPresencialController from "../controller/sessao-presencial.controller";

interface Props {
  controller: EventoVisualizarController;
}

export default function SessaoPresencialDefinitiva({ controller }: Props) {
  const evento = controller.evento;
  const _controller = new SessaoPresencialController();
  const lista: any = _controller.lista;

  useEffect(() => {
    if (
      controller.tab === "sessao-presencial" &&
      (evento.cdTpEvento === 1 || evento.cdTpEvento == 4)
    ) {
      _controller.init();
    }
  }, [controller.tab, evento.cdTpEvento]);

  return (
    <>
      <If
        condition={
          controller.tab === "sessao-presencial" &&
          (evento.cdTpEvento === 1 || evento.cdTpEvento == 4)
        }
      >
        <Card className="evento-vis-card-tab">
          <div className="evento-sessao-presencial">
            <If condition={!!lista && lista.length > 0}>
              {!!lista &&
                lista.map((m: any, xindex: any) => (
                  <SessaoPresencialVisualizar
                    key={`sessao-presencial-${xindex}`}
                    sessaoPresencial={{
                      sessao: m.sessao,
                      horario: m.horario,
                      tpFormatoSessao: m.tpFormatoSessao,
                      local: m.local,
                      formulario: m.formulario,
                    }}
                  />
                ))}
            </If>
            <If condition={!lista || lista.length === 0}>
              <h4 className="text-center">Nenhum dado encontrado</h4>
            </If>
          </div>
        </Card>
      </If>
    </>
  );
}
